import React from 'react'
import { sizes, socialIconColors } from './const'
export interface InstagramProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_TrackIcon", which is used for Google Analitics.
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * The color of the icon including the cirlce.
     * */
    color?: 'white' | 'black'
}

export const InstagramIcon = ({
    className = 'js_InstagramIcon',
    size = 'large',
    color = 'black',
}: InstagramProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`${className} ${sizes[size]}`}
            fill="none"
            viewBox="0 0 32 32"
        >
            <g fillRule="evenodd">
                <circle
                    className={`${socialIconColors[color][0]}`}
                    cx={16}
                    cy={16}
                    r={15.5}
                />
                <g
                    transform="translate(8.533 8.533)"
                    className={`${socialIconColors[color][1]}`}
                >
                    <path d="M7.525 3.719a3.755 3.755 0 0 0-3.748 3.748 3.737 3.737 0 0 0 3.748 3.748 3.755 3.755 0 0 0 3.748-3.748c0-2.05-1.698-3.748-3.748-3.748zm0 6.149a2.412 2.412 0 0 1-2.4-2.401 2.412 2.412 0 0 1 2.4-2.401 2.412 2.412 0 0 1 2.401 2.4 2.412 2.412 0 0 1-2.4 2.402z" />
                    <circle cx={11.42} cy={3.631} r={1} />
                    <path d="M13.616 1.435c-.762-.79-1.845-1.2-3.075-1.2H4.51C1.962.234.264 1.932.264 4.48v6.003c0 1.259.41 2.342 1.23 3.133.79.761 1.844 1.142 3.045 1.142h5.973c1.259 0 2.313-.41 3.074-1.142.791-.762 1.2-1.845 1.2-3.104V4.48c0-1.23-.409-2.284-1.17-3.045zm-.176 9.077c0 .908-.264 1.64-.79 2.137-.528.498-1.26.762-2.138.762H4.539c-.879 0-1.61-.264-2.138-.762-.527-.527-.79-1.259-.79-2.166V4.48c0-.878.263-1.61.79-2.138.498-.497 1.26-.76 2.138-.76h6.031c.879 0 1.61.263 2.138.79.498.527.79 1.259.79 2.108v6.032h-.058z" />
                </g>
            </g>
        </svg>
    )
}
